import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { Parallax } from "react-parallax";
import { AppContext } from "../main";
import { loadStripe } from "@stripe/stripe-js";

const stripePublishableKey = process.env.REACT_APP_STRIPE_KEY_MODUPE
const productID = process.env.REACT_APP_STRIPE_PRODUCT_ID_MODUPE

const stripePromise = loadStripe(stripePublishableKey);

const GlobalStyles = createGlobalStyle`
  .de_pricing-table .d-recommend{
    background: var(--primary-color);
  }
  .de_pricing-table.type-2.rec {
    border: solid 5px var(--primary-color) !important;
  }
  .dark-scheme .de_pricing-table.type-2{
    border: 0px;
  }
  .de_pricing-table .d-price h4{
    font-family: var(--body-font);
    span{
        font-size: 14px;
    }
  }
`;

const Server = (props) => {
  const { handleEditItem } = props;

  const { appState } = useContext(AppContext);
  const {
    pricelists = {
     
    },
    editMode = false,
  } = appState;

  const [isChecked, setIsChecked] = useState(false);
  const handleToggle = () => {
    setIsChecked((prevState) => !prevState);
  };
  const switchClassName = isChecked ? "switch checked" : "switch";
  const otherElementClassName = isChecked
    ? "other-element active"
    : "other-element";

  if (!pricelists?.plans) {
    return null;
  }

  const handlePayment = async (priceId) => {
    try {
      const stripe = await stripePromise;

      // Redirect to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        lineItems: [
          {
            price: priceId, // The ID of the price you created in Stripe dashboard
            quantity: 1,
          },
        ],
        mode: "subscription",
        successUrl: window.location.origin + "/success",
        cancelUrl: window.location.origin + "/cancel",
      });

      if (error) {
        console.error(error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <GlobalStyles />
      <div className="de-gradient-edge-top"></div>
      <div className="de-gradient-edge-bottom"></div>
      <div className="container z-9">
        <div className="row">
          <div className="col-lg-6 offset-lg-3 text-center">
            <div className="subtitle fadeInUp mb-3">
              {pricelists.PRICING_PLANS_TITLE}
            </div>
            <h2 className="fadeInUp mb20">{pricelists.CHOOSE_PLAN_TEXT}</h2>
            <div className="switch-set">
              <div>{pricelists.MONTHLY_PLAN_TEXT}</div>
              <div>
                <input
                  id="sw-1"
                  className={switchClassName}
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleToggle}
                />
              </div>
              <div>{pricelists.YEARLY_PLAN_TEXT}</div>
              <div className="spacer-20"></div>
            </div>
          </div>

          <div className="clearfix"></div>
          {pricelists.plans.map((plan, index) => (
            <div key={index} className="col-xl-4 col-md-6 mb-sm-30 fadeInRight">
              <div
                className={`de_pricing-table type-2 ${plan.bestSeller ? "rec" : ""
                  } ${otherElementClassName}`}
              >
                {plan.bestSeller && (
                  <div className="d-recommend">Top Seller</div>
                )}
                <div className="d-title">{plan.title}</div>
                <div className="d-stars">
                  {Array(index + 1).fill(<i className="fa fa-star"></i>)}
                </div>
                <div className="spacer-20"></div>
                <div className="d-specs">
                  <div className="row">
                    {plan?.itemA && <div className="col-6">
                      <div className="d-item">
                        {/* {plan.slots} */}
                        <span>{plan?.itemA}</span>
                      </div>
                    </div>}
                    {plan?.itemB && <div className="col-6">
                      <div className="d-item">
                        {/* {plan.memory} */}
                        <span>{plan?.itemB}</span>
                      </div>
                    </div>}
                  </div>
                </div>
                <div className="spacer-20"></div>
                <div className="d-price text-center mb-0">
                  <h4 className="opt-1 mb-0">
                    ${plan.priceMonthly} <span>/monthly</span>
                  </h4>
                  <h4 className="opt-2 mb-0">
                    ${plan.priceYearly} <span>/monthly</span>
                  </h4>
                  <p className="opt-1">{plan?.slots}</p>
                  <p className="opt-2">$0.25 per slot </p>
                </div>
                <div className="d-action">
                  {/* <Link to="/" className="btn-main w-100">Order Now</Link> */}
                  <button
                    onClick={() => handlePayment(plan.priceId)} //todo:dee
                    className="btn-main opt-1 w-100"
                  >
                    Order Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Server;
